
export const dumbledoreMediaArray = [
  {
    _id: 'dumbledoreMediaId1',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-1-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-1-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `You know what they say about long beards`,
      `That feeling of wearing your favorite robe`,
      `You won't find a 189 year old with a better head of hair`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId2',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-2-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-2-p.png`,
    description: ``,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Modeling my new line of beard-ties`,
      `Feeling blue, but only until I meet you`,
      `Let's pretend I'm thinking something profound`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId3',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-3-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `When the lighting shows every wrinkle on your face`,
      `The sign of being old is when you actually want the camera to pick up all your wrinkles`,
      `Did I leave the toilet seat up?`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId4',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-4-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-4-p.png`,
    description: ``,
    captions: [
      `Woke up like this`,
      `#MondaysAmIRight?`,
      `My best blue steel`
    ],
    subcaptions: [
      `You know what they say about long beards`,
      `That feeling of wearing your favorite robe`,
      `You won't find a 189 year old with a better head of hair`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId5',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-5-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `Yes, you've died and gone to heaven... by dating me`,
      `Trying very hard to look serious`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId6',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-6-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-6-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `When your beard doubles as a weather vane`,
      `Gale force winds — proof that I'm not wearing a toupé`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId7',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-7-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-7-p.png`,
    description: ``,
    captions: [
      `My quarter life crisis looks like`,
      `My uniform`,
      `My best blue steel`
    ],
    subcaptions: [
      `Go on a date with me or else`,
      `Trying to make a Patronus but only Lumos is coming out`,
      `Wanna check out my Elder(ly) Wand`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId8',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-8-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-8-p.png`,
    description: ``,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Tell me my hair looks good or else`,
      `Trying very hard to remember what I ate for breakfast this morning`,
      `Trying very hard to remember what it was like to not be old`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'dumbledoreMediaId9',
    userId: 'dumbledoreUserId',
    email: 'dumbledore@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-9-sq.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-9-p.png`,
    description: ``,
    captions: [
      `Felt cute might delete later`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Doing my best Gandalf impersonation`,
      `Options include 'masculine', 'virile', and 'beguiling'`,
      `The world is your dragonwalk`
    ],
    tags: [
      ``,
      ``,
      ``
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]